import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

import { from } from 'rxjs';
import { ResponseUpdateItem, StepItemConfig } from '@sondermind/utilities/models-flows';
import { PipesModule } from '@sondermind/utilities/pipes';

import { IrisButtonModule, IrisButtonTypes } from '@sondermind/iris/button';
import { SegmentService } from '@sondermind/segment';

import { StepComponent } from '../step.component';
import { WizardService } from '../../../services/wizard.service';
import {
  FlowsHostSegmentEvents,
  IClinicalQuestionnaireClickedDoneData,
  IFlowsHostSegmentSchema
} from '../../../models/flows-host-segment-schema.interface';

interface IAssessmentCompleteConfig extends StepItemConfig {
  content?: string;
  helpText: string;
}

@Component({
  selector: 'assessment-complete',
  standalone: true,
  imports: [
    CommonModule,
    PipesModule,
    IrisButtonModule,
  ],
  templateUrl: './assessment-complete.component.html',
  styleUrls: ['./assessment-complete.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AssessmentCompleteComponent extends StepComponent<IAssessmentCompleteConfig> implements OnInit {
  irisButtonTypes = IrisButtonTypes;

  constructor(
    wizard: WizardService,
    private segmentService: SegmentService<IFlowsHostSegmentSchema>
  ) {
    super(wizard);
  }

  get hasContext(): boolean {
    return !!this.wizard.context;
  }

  get staticIntroContent(): string {
    const content = this.hasContext ? this.wizard.context : this.config.content;

    return content ?? '';
  }

  get helpText(): string {
    const helpText = this.hasContext ? this.wizard.context : this.config.helpText;

    return helpText ?? '';
  }

  onClickDone(): void {
    this.sendClickDoneSegmentEvent();

    this.wizard.complete().subscribe(() => {
      if (this.config.url) {
        const url = this.buildAbsoluteUrl(this.config.url);
        window.location.assign(url);
      }
    });
  }

  onSubmit(): ResponseUpdateItem[] {
    return [];
  }

  ngOnInit(): void {
    this.valid.next(!!this.component.next);
  }

  sendClickDoneSegmentEvent(): void {
    const buttonText: string = this.component.done;
    const cqType: string = this.wizard.getSlug();
    const { isPaginated, questionnaireId } = this.wizard;

    const data: IClinicalQuestionnaireClickedDoneData = {
      buttonText,
      cqType,
      isPaginated,
      questionnaireId
    };

    from(
      this.segmentService.track(FlowsHostSegmentEvents.CQ_CLICKED_DONE, data)
    ).subscribe();
  }

  private buildAbsoluteUrl(href: string): string {
    const link = document.createElement('a');
    link.href = href;

    return link.href;
  }
}
